import { DayOfWeek } from '@caresend/types';
import { militaryHourToTime, capitalize, buildBulletSeparatedString } from '@caresend/utils';

const formatDayOfWeek = (dayOfWeek, format) => {
    if (format === 'short') {
        switch (dayOfWeek) {
            case (DayOfWeek.MONDAY):
            case (DayOfWeek.WEDNESDAY):
            case (DayOfWeek.FRIDAY):
                return capitalize(dayOfWeek)[0];
            case (DayOfWeek.TUESDAY):
            case (DayOfWeek.THURSDAY):
            case (DayOfWeek.SATURDAY):
            case (DayOfWeek.SUNDAY):
                return capitalize(dayOfWeek).substr(0, 2);
        }
    }
    return capitalize(dayOfWeek);
};
const formatOpeningHours = (openingHours, dayFormat = 'long') => {
    const groupedHours = {};
    const sortHourStrings = (a, b) => {
        const aVal = Number(a.openingHour.timeFrom);
        const bVal = Number(b.openingHour.timeFrom);
        return aVal - bVal;
    };
    const sortDays = (a, b) => {
        var _a, _b;
        const aDayOfWeek = (_a = a[0]) === null || _a === void 0 ? void 0 : _a.openingHour.dayFrom;
        const bDayOfWeek = (_b = b[0]) === null || _b === void 0 ? void 0 : _b.openingHour.dayFrom;
        if (!aDayOfWeek && !bDayOfWeek)
            return 0;
        if (!aDayOfWeek)
            return 1;
        if (!bDayOfWeek)
            return -1;
        const aVal = Object.values(DayOfWeek).indexOf(aDayOfWeek);
        const bVal = Object.values(DayOfWeek).indexOf(bDayOfWeek);
        return aVal - bVal;
    };
    const formatGroupedHours = (hoursWithFormat) => {
        var _a, _b;
        const days = (_b = (_a = hoursWithFormat[0]) === null || _a === void 0 ? void 0 : _a.formattedDays) !== null && _b !== void 0 ? _b : '';
        const times = buildBulletSeparatedString(hoursWithFormat.map(({ formattedTimes }) => formattedTimes));
        return { days, times };
    };
    const joiner = dayFormat === 'short' ? '-' : ' to ';
    openingHours.forEach((openingHour) => {
        var _a;
        const dayFrom = formatDayOfWeek(openingHour.dayFrom, dayFormat);
        const dayTo = formatDayOfWeek(openingHour.dayTo, dayFormat);
        const timeFrom = militaryHourToTime(Number(openingHour.timeFrom));
        const timeTo = militaryHourToTime(Number(openingHour.timeTo));
        const formattedDays = dayFrom === dayTo ? `${dayFrom}` : `${dayFrom}${joiner}${dayTo}`;
        const formattedTimes = `${timeFrom}${joiner}${timeTo}`;
        const hours = (_a = groupedHours[formattedDays]) !== null && _a !== void 0 ? _a : [];
        hours.push({ openingHour, formattedTimes, formattedDays });
        hours.sort(sortHourStrings);
        groupedHours[formattedDays] = hours;
    });
    const formattedGroupedHours = Object.values(groupedHours)
        .sort(sortDays)
        .map(formatGroupedHours);
    return formattedGroupedHours;
};

export { formatDayOfWeek, formatOpeningHours };
